<script>
  import Navigation from "./Navigation.svelte"
  import {onDestroy, onMount} from 'svelte';
  import Projects from "./Projects.svelte";
  import Contracting from "./Contracting.svelte";
  import Adventures from "./Adventures.svelte";
  import {CacheLoadState, preFetchMemories, refreshPath} from "./EndpointsAndTransforms";
  import {modalStatus, currentNav} from "./Stores.js";
  import ModalDisplay from "./ModalDisplay.svelte";
  import Rants from "./Rants/Rants.svelte";

  let cacheState = CacheLoadState.loading
  onMount(() => {
    refreshPath()

    preFetchMemories(
      [
      '383BFF3D-C8D2-41ED-829E-A0A868970696',
      '6F598324-D966-4389-87B5-5AB8A41755B8',
      'D81EAA03-1FAF-489C-B6D1-D2F5ECD5C615',
      '7ADDD607-006C-44B8-84DF-EDE6F936E0DE',
      '6B21B418-A8A5-40CF-B955-B49FC0DAB7DE',
      'DF6CB0AF-452C-4119-A5A3-F97ABDB02971',
      '1A6A82A2-BF9C-4258-8C6F-2FBDDCCF6873',
      ],

      (state) => {
      cacheState = state
      }
    )
  })

  window.addEventListener('popstate', refreshPath)
  onDestroy(() => { window.removeEventListener('popstate', refreshPath) })

</script>


<main>
  <globalLayoutContainer>
    <nav>
      <Navigation/>
    </nav>

    <topDivider/>

    <realContent>
      {#if $currentNav === 'projects'}        <Projects/>
      {:else if $currentNav === 'rates'}      <Contracting/>
      {:else if $currentNav === 'rants'}      <Rants/>
      {:else if $currentNav === 'adventures'} <Adventures/>
      {:else}
        <h2>404'd!!</h2>
        <p>Something's not right with this address.</p>
      {/if}
    </realContent>

    <bottomDivider/>

    <footer>
      <offCentered>
        <p>r @ ryancumley.io</p>
      </offCentered>
    </footer>

  </globalLayoutContainer>
</main>

<modal class:active="{$modalStatus === 'on'}">
  <ModalDisplay/>
</modal>

<style>
  modal {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0,0,0,1);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0s 0.2s;


    z-index: 101;
  }
  .active {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.2s;
  }
  modal h1 {
    color: white;
  }

	main {
		text-align: center;
    margin-left: auto;
    margin-right: auto;
    height: 100vh; width: 100vw;
	}

  globalLayoutContainer {
    width: 100vw;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    display: grid;
    grid-template-columns: 300px auto;
    grid-template-rows: 70px 1px auto 1px 40px;
    grid-template-areas:
      "nav nav"
      "topDivider topDivider"
      "realContent realContent"
      "bottomDivider bottomDivider"
      "footer footer"
        ;
    justify-items: stretch;
    align-items: stretch;
    overflow: visible;
  }

  @media only screen and (max-width: 600px) {
    globalLayoutContainer {
      max-width: 100%;
    }
  }

  nav {
    grid-area: nav;
  }

  topDivider {
    grid-area: topDivider;

    background-color: rgba(107,118,141,0.3);
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }

  realContent {
    grid-area: realContent;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: flex-start;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;

    overflow-y: scroll;
    scrollbar-width:none;
  }
  realContent::-webkit-scrollbar {
    display: none;
  }

  bottomDivider {
    grid-area: bottomDivider;
    background-color: rgba(107,118,141,0.3);
    width: 100%;
    height: 1px;
  }

  footer {
    grid-area: footer;
  }
  offCentered {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-start;
  }

  footer p {
    margin-right: 3rem;
  }

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>